var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "feature card-item" }, [
    !_vm.checkUserFeature("nav.settings.users-permissions")
      ? _c("div", { attrs: { id: "notPermissions" } }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("permissions")))]),
        ])
      : _c(
          "div",
          [
            _c("Spinner", {
              attrs: { id: "spinner", "is-loading": _vm.isLoading },
            }),
            !_vm.isLoading
              ? _c(
                  "div",
                  {
                    staticClass: "feature card-item",
                    attrs: { id: "search-container" },
                  },
                  [
                    _vm.showList
                      ? _c(
                          "div",
                          [
                            _c(
                              "div",
                              { staticClass: "mt-4 pb-4" },
                              [
                                _c("b-taginput", {
                                  staticClass: "taginput",
                                  attrs: {
                                    id: "filter-input",
                                    rounded: "",
                                    size: "is-small",
                                    data: _vm.filteredUsersTagsList,
                                    autocomplete: "",
                                    "allow-new": true,
                                    "open-on-focus": true,
                                    field: "feature.name",
                                    placeholder: _vm.$t("filter"),
                                    "close-type": "is-success",
                                  },
                                  on: { typing: _vm.finderUsers },
                                  model: {
                                    value: _vm.userFilters,
                                    callback: function ($$v) {
                                      _vm.userFilters = $$v
                                    },
                                    expression: "userFilters",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._l(_vm.findedUsers, function (user, i) {
                              return _c(
                                "div",
                                {
                                  key: i,
                                  staticClass:
                                    "feature user-item card-item shadowless",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "user-item-info clearfix" },
                                    [
                                      _c("div", { staticClass: "text-info" }, [
                                        user.userFeaturesConfig &&
                                        user.userFeaturesActive
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "tag is-medium is-success is-light",
                                                attrs: {
                                                  id: `activate-user-${user._id}`,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("activated"))
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        user.userFeaturesConfig &&
                                        !user.userFeaturesActive
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "tag is-medium is-info is-light",
                                                attrs: {
                                                  id: `deactivate-user-${user._id}`,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("deactivated"))
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        !user.userFeaturesConfig
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "tag is-medium is-danger is-light",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("notConfigured")
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text has-text-weight-bold title-label",
                                          },
                                          [_vm._v(_vm._s(user.name || "N/A"))]
                                        ),
                                        _c("div", [
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v(_vm._s(user.email)),
                                          ]),
                                        ]),
                                        _c("div", [
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v(
                                              _vm._s(_vm.$t("role")) +
                                                ": " +
                                                _vm._s(user.rol || "N/A")
                                            ),
                                          ]),
                                        ]),
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "b-tooltip",
                                              {
                                                attrs: {
                                                  size: "is-medium",
                                                  multilined: "",
                                                  position: "is-top",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "content",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "tootip-title",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t("path")
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                user.allowedFrontRoutesNames
                                                                  ? user.allowedFrontRoutesNames.join(
                                                                      ", "
                                                                    )
                                                                  : "N/A"
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa-solid fa-location-dot",
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          [
                                            user.userFeaturesConfig &&
                                            !user.userFeaturesActive
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "button is-button-primary is-rounded",
                                                    attrs: {
                                                      id: `activate-button-${user._id}`,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.activeUser(
                                                          user
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t("activate")
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _c("div", [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "button is-button-secondary is-rounded",
                                              attrs: { id: `user-${user._id}` },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.clickedOnUser(user)
                                                },
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("config")) +
                                                    " "
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                        _c("div", [
                                          _vm.checkUserFeature(
                                            "element.settings.user.button.delete"
                                          )
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    id: `delete-button-${user._id}`,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setConfirmDelete(
                                                        user._id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "fa-solid fa-trash fa-x2",
                                                    attrs: { disablerd: true },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                      ]),
                                      _vm.confirmDelete === user._id
                                        ? _c(
                                            "div",
                                            { staticClass: "delete-info" },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "is-text" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "confirmDeleteUser"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "is-button-primary is-small is-rounded",
                                                  attrs: {
                                                    id: `confirm-delete-button-${user._id}`,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.deleteUser(user)
                                                      _vm.setConfirmDelete("")
                                                    },
                                                  },
                                                },
                                                [_c("span", [_vm._v(" Si ")])]
                                              ),
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "is-text",
                                                  attrs: { id: "ask-button" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setConfirmDelete(
                                                        ""
                                                      )
                                                    },
                                                  },
                                                },
                                                [_c("span", [_vm._v(" No ")])]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    !_vm.showList && _vm.selectedUser
                      ? _c(
                          "div",
                          { attrs: { id: "features-container" } },
                          [
                            _c(
                              "div",
                              [
                                !_vm.showList
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "is-button-primary ml-2 mt-1 is-small is-rounded is-pulled-right",
                                        attrs: { id: "back-button" },
                                        on: { click: () => _vm.goBack() },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            " " + _vm._s(_vm.$t("return")) + " "
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "default-client-header" },
                              [
                                _c("div", { staticClass: "header-name" }, [
                                  _c("h3", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          `${_vm.$t("userPermissions")} ${
                                            _vm.selectedUser.name || ""
                                          } ${_vm.selectedUser.lastName || ""}`
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "mt-3" },
                                [
                                  _c("b-field", { attrs: { expanded: "" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "column is-flex is-vcentered pl-0 pb-0",
                                      },
                                      [
                                        _c(
                                          "b-field",
                                          [
                                            _c(
                                              "b-select",
                                              {
                                                attrs: {
                                                  id: "select-section",
                                                  placeholder:
                                                    _vm.$t("selectSection"),
                                                  size: "is-small",
                                                  rounded: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.selectedSectionName,
                                                  callback: function ($$v) {
                                                    _vm.selectedSectionName =
                                                      $$v
                                                  },
                                                  expression:
                                                    "selectedSectionName",
                                                },
                                              },
                                              _vm._l(
                                                [_vm.$t("without")].concat(
                                                  _vm.sections.map(
                                                    (section) => section.name
                                                  )
                                                ),
                                                function (sectionName, i) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: i,
                                                      attrs: { id: "cobranza" },
                                                      domProps: {
                                                        value: sectionName,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(sectionName) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-field",
                                          {
                                            staticClass:
                                              "is-flex is-vcentered ml-3",
                                          },
                                          [
                                            _c(
                                              "b-checkbox",
                                              {
                                                attrs: {
                                                  disabled:
                                                    !_vm.selectedSection,
                                                  size: "is-small",
                                                  "native-value": "read",
                                                },
                                                model: {
                                                  value:
                                                    _vm.selectedSectionMode,
                                                  callback: function ($$v) {
                                                    _vm.selectedSectionMode =
                                                      $$v
                                                  },
                                                  expression:
                                                    "selectedSectionMode",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("read")) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "b-checkbox",
                                              {
                                                attrs: {
                                                  disabled:
                                                    !_vm.selectedSection,
                                                  size: "is-small",
                                                  "native-value": "write",
                                                },
                                                model: {
                                                  value:
                                                    _vm.selectedSectionMode,
                                                  callback: function ($$v) {
                                                    _vm.selectedSectionMode =
                                                      $$v
                                                  },
                                                  expression:
                                                    "selectedSectionMode",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("write")) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "column pb-0" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            class: _vm.userIdsByCOuntry.cl
                                              ? ""
                                              : "img-gray",
                                          },
                                          [
                                            _c("img", {
                                              staticClass:
                                                "fas fa-2 is-pulled-right mt-2 mr-2",
                                              attrs: {
                                                src: require("@/ui/assets/img/chile.png"),
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            class: _vm.userIdsByCOuntry.br
                                              ? ""
                                              : "img-gray",
                                          },
                                          [
                                            _c("img", {
                                              staticClass:
                                                "fas fa-2 is-pulled-right mt-2 mr-2",
                                              attrs: {
                                                src: require("@/ui/assets/img/brasil.png"),
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            class: _vm.userIdsByCOuntry.pe
                                              ? ""
                                              : "img-gray",
                                          },
                                          [
                                            _c("img", {
                                              staticClass:
                                                "fas fa-2 is-pulled-right mt-2 mr-2",
                                              attrs: {
                                                src: require("@/ui/assets/img/peru.png"),
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "b-field",
                                          {
                                            staticClass:
                                              "is-flex is-vcentered check is-pulled-right mr-2",
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "is-size-7 mt-1 mr-2",
                                              },
                                              [_vm._v(" clonar ")]
                                            ),
                                            _c("b-switch", {
                                              attrs: {
                                                id: "clone-features",
                                                disabled: !(
                                                  _vm.userIdsByCOuntry.cl ||
                                                  _vm.userIdsByCOuntry.br ||
                                                  _vm.userIdsByCOuntry.pe
                                                ),
                                                type: "is-success",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.cloneAllFeatures()
                                                },
                                              },
                                              model: {
                                                value: _vm.switchCloneAll,
                                                callback: function ($$v) {
                                                  _vm.switchCloneAll = $$v
                                                },
                                                expression: "switchCloneAll",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "column pb-0" },
                                      [
                                        _c(
                                          "b-field",
                                          {
                                            staticClass:
                                              "is-flex is-vcentered check is-pulled-right mr-2",
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "is-size-7 mt-1 mr-2",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.switchAllowAll
                                                      ? _vm.$t("desactiveAll")
                                                      : _vm.$t("activateAll")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("b-switch", {
                                              attrs: {
                                                id: "set-all-features",
                                                type: "is-success",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.setAllowAllFeatures()
                                                },
                                              },
                                              model: {
                                                value: _vm.switchAllowAll,
                                                callback: function ($$v) {
                                                  _vm.switchAllowAll = $$v
                                                },
                                                expression: "switchAllowAll",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "mt-4 pb-4" },
                              [
                                _c("b-taginput", {
                                  attrs: {
                                    id: "filter-input",
                                    rounded: "",
                                    data: _vm.filteredTags,
                                    autocomplete: "",
                                    "before-adding": _vm.beforeAdding,
                                    "allow-new": true,
                                    "open-on-focus": true,
                                    field: "feature.name22",
                                    placeholder: _vm.$t("filter"),
                                    "close-type": "is-success",
                                  },
                                  on: { typing: _vm.getFilteredTags },
                                  model: {
                                    value: _vm.filters,
                                    callback: function ($$v) {
                                      _vm.filters = $$v
                                    },
                                    expression: "filters",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._l(
                              _vm.filteredUserFeaturesMap,
                              function (feature) {
                                return _c(
                                  "div",
                                  {
                                    key: feature.name,
                                    staticClass: "feature card-item shadowless",
                                    attrs: { id: `feature-${feature.name}` },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "feature-body" },
                                      [
                                        _c(
                                          "b-field",
                                          {
                                            staticClass:
                                              "check is-pulled-right",
                                          },
                                          [
                                            _c("b-switch", {
                                              attrs: {
                                                id: `switch-${feature.name}-${feature.allowed}`,
                                                type: "is-success",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.updateFeaturePermission(
                                                    feature.name
                                                  )
                                                },
                                              },
                                              model: {
                                                value: feature.allowed,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    feature,
                                                    "allowed",
                                                    $$v
                                                  )
                                                },
                                                expression: "feature.allowed",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("h3", [
                                          _vm._v(_vm._s(feature.description)),
                                        ]),
                                        _c("p", [_vm._v(_vm._s(feature.name))]),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }